import React, { useMemo, useState, Suspense } from "react";

import { Switch, Route, Redirect } from "react-router-dom";

const App = React.memo(function (props) {
  const {
    location: { pathname },
    first = "",
    SubRoutes,
  } = props;
  // const [SubRoutes, setSubRoutes] = useState([]);
  const [RouterNodes, setRouterNodes] = useState([]);
  useMemo(() => {
    const routeNodes = [];

    function RouteWithSubRoutes({ component, children, path }) {
      if (component) {
        routeNodes.push({ component, path });
      }
      if (children?.length) {
        return children.forEach(RouteWithSubRoutes);
      }
    }
    SubRoutes.forEach(RouteWithSubRoutes);
    setRouterNodes(routeNodes);
  }, [SubRoutes]);
  const isEffective = useMemo(() => {
    const flatArray = (arr, d = 1) => {
      return d > 0
        ? arr.reduce((acc, val) => {
            const temp = [...acc, val];

            return temp.concat(
              Array.isArray(val.children) ? flatArray(val.children, d - 1) : []
            );
          }, [])
        : arr.slice();
    };
    const result = flatArray(SubRoutes, Infinity).find(
      (ts) => ts.path === pathname
    );
    return result;
  }, [pathname, SubRoutes]);
  return (
    <Switch>
      {RouterNodes.map(({ path, component }) => {
        const LazyComponent = React.lazy(component);
        return isEffective ? (
          <Route
            key={path}
            exact
            path={path}
            render={(props) => (
              <Suspense fallback={<div>loading</div>}>
                <LazyComponent {...props} />
              </Suspense>
            )}
          />
        ) : (
          <Route>
            <Redirect to={"/403"} />
          </Route>
        );
      })}
    </Switch>
  );
})
export default App;
